export const dashboardRequestsFilter = (requests) => {
  const obj = {
    new: [],
    annulled: [],
    closed: [],
    done: [],
    inWork: [],
  }

  requests.forEach((request) => {
    if (request.status === 'Новая') {
      obj.new.push(request)
    }

    if (request.status === 'Аннулирована') {
      obj.annulled.push(request)
    }

    if (request.status === 'Выполнена') {
      obj.done.push(request)
    }

    if (request.status === 'Выполнена(контроль качества)') {
      obj.done.push(request)
    }

    if (request.status === 'В работе') {
      obj.inWork.push(request)
    }

    if (request.status === 'Закрыта') {
      obj.closed.push(request)
    }
  })

  return obj
}